(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ss-footer-wave"] && !Shopify.designMode) return;
  try {
    (() => {
  const observer = new IntersectionObserver(entries => entries.forEach(entry => entry.target.classList.toggle('is-visible', entry.isIntersecting)));
  document.querySelectorAll('.ss-footer-wave').forEach(element => observer.observe(element));
})();
  } catch(e) { console.error(e); }
})();

})();
